import { GameDocument } from '../../types/game-document';
import { GetResourceEntity } from './resources';

/**
 * Get resource pack's resource by name.
 * @param gameDocument - The Game Document to modify
 * @param name - Name of resource pack
 * @param resourceId - Resource Id you want to search
 * @return The Resource pack's resource
 */
export const GetResourcePackResourceValue = (
  gameDocument: GameDocument,
  name: string,
  resourceId: string
): string => {
  if (!gameDocument || !name || !resourceId) return '';

  const selectedResourcePack = gameDocument?.resourcePacks?.find(
    (x) => x.name === name
  );

  const value =
    selectedResourcePack?.resources?.find((x) => x.id === resourceId)?.value ??
    '';

  if (!value) {
    const res = GetResourceEntity(gameDocument, resourceId).value ?? '';
    if ((res as string | Blob) instanceof Blob)
      return URL.createObjectURL(res as unknown as Blob);
    return res;
  }

  if ((value as string | Blob) instanceof Blob)
    return URL.createObjectURL(value as unknown as Blob);
  return value;
};
